import { useState, useEffect } from 'react';
import css from './StaffOverview.module.css';

import * as staffServices from '../../../../../services/staffServices';

import Table from '../../../_common/data/Table';
import ModalForm from '../../../_common/ModalForm';
import AddNewStaff from './AddNewStaff';
// import AddNewCourse from './AddNewCourse';

function StaffOverview() {
    const [staff, setStaff] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        let page;
        staffServices
            .getAll(page || 1)
            .then((result) => {
                // setStaff((state) => result.data.sort((a, b) => b.ID-a.ID) || []);
                setStaff((state) => result.data || []);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [showModal]);

    // const onAdd = (newData) => {
    //     setStaff((state) => [
    //         {
    //             ID: newData.courseNo,
    //             Title: newData.courseTitle,
    //             Type: '',
    //             Start: newData.courseStart,
    //             End: newData.courseEnd,
    //             Status: 'Acquisition',
    //         },
    //         ...state,
    //     ]);
    // };

    //Open and close the input form
    const toggleModal = () => setShowModal(!showModal);

    //Provides the start of the link for the details
    const detailsTo = '/staff/details/';

    return (
        <div className={css.main}>
            <div>
                <Table data={staff} detailsTo={detailsTo} />
            </div>
            <div>
                <div>
                    <button onClick={toggleModal} className={css.button}>
                        +
                    </button>
                    <ModalForm showModal={showModal}>
                        <AddNewStaff data={staff} toggleModal={toggleModal} />
                    </ModalForm>
                </div>
                <></>
            </div>
        </div>
    );
}

export default StaffOverview;

